<template>
	<div
		class="ticketing-tab-processing"
		:class="{ 'ticketing-tab-processing--dark': darkTheme }"
	>
		<div
			v-if="customerNameToPrint"
			class="ticketing-tab-processing__customer-name"
		>
			{{ customerNameToPrint }}
		</div>
		<div class="ticketing-tab-processing__text">
			OPENING YOUR
		</div>
		<div class="ticketing-tab-processing__logo">
			<img alt="smartTab" :src="darkTheme ? whiteLogoIcon : logoIcon" />
		</div>
		<div class="three-glass-animation-wrapper">
			<three-glass-animation />
		</div>
	</div>
</template>

<script>
import ThreeGlassAnimation from '@/components/Loaders/ThreeGlassAnimation.vue'
import LogoIcon from '@/assets/images/logo.svg'
import WhiteLogoIcon from '@/assets/images/logo_white.svg'

export default {
	name: 'TicketingTabProcessing',
	components: {
		ThreeGlassAnimation
	},

	props: {
		customerNameToPrint: {
			type: String,
			default: ''
		},

		darkTheme: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		logoIcon() {
			return LogoIcon
		},

		whiteLogoIcon() {
			return WhiteLogoIcon
		}
	}
}
</script>

<style scoped lang="scss">
@import './src/assets/styles/variables';

.ticketing-tab-processing {
	height: 100%;
	padding: 30px 15px 15px;
	overflow: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	color: $grey-dark;
	font-size: 16px;
	line-height: 22px;
	background-color: $white;

	&__logo {
		width: 199px;
		height: 17px;
		margin-top: 10px;
		img {
			width: 100%;
			height: auto;
		}
	}

	&__customer-name {
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 24px 29px 40px;
		font-weight: 300;
		font-size: 24px;
		letter-spacing: 0.5px;
	}

	&__animated-logo {
		margin-bottom: 185px;
	}

	&__text {
		font-weight: 300;
		margin-bottom: 3px;
	}

	&--dark {
		background-color: $midnight-navy;

		.customer-name,
		.text-loader,
		.ticketing-tab-processing__customer-name,
		.ticketing-tab-processing__text {
			color: $white;
		}
	}
}

.three-glass-animation-wrapper {
	width: calc(100% + 30px);
	margin-left: -15px;
	margin-right: -15px;
	overflow: hidden;
	margin-top: 16vh;

	.three-glasses-animation {
		display: block;
		@media (max-width: 1600px) {
			width: 150%;
		}
		@media (max-width: 1204px) {
			width: 250%;
		}
		@media (max-width: 768px) {
			width: 300%;
		}
		@media (max-width: 640px) {
			width: 562%;
		}
	}
}
</style>
